import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const notificationsManagement = createApi({
    reducerPath: "notificationsManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        notificationsList: builder.mutation({
            query: (userId) => {
                let url = `v1/${locale}/notifications/${userId}`;

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

        markOneAsRead: builder.mutation({
            query: ({ userId, notificationId }) => ({
                url: `v1/${locale}/notifications/${userId}/mark-one-as-read/${notificationId}`,
                method: "PATCH",
            }),
        }),

        markAllAsRead: builder.mutation({
            query: (userId) => ({
                url: `v1/${locale}/notifications/${userId}/mark-all-as-read`,
                method: "PATCH",
            }),
        }),

        totalUnread: builder.mutation({
            query: (userId) => {
                let url = `v1/${locale}/notifications/${userId}/total-unread`;

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),

    }),
});

export const { 
    useNotificationsListMutation,
    useMarkOneAsReadMutation,
    useMarkAllAsReadMutation,
    useTotalUnreadMutation
} = notificationsManagement;
